<template>
  <b-table
    hover
    striped
    :fields="fields"
    :items="reactables"
  >
    <template slot="index" slot-scope="row">
      {{ row.index + 1 }}
    </template>

    <template slot="reactable" slot-scope="{ item }">
      <a :href="item.link" target="_blank">{{ item.title }}</a>
    </template>

    <template slot="actions" slot-scope="{ item }">
      <div class="d-flex">
        <like-button
          :to="item.reactable_type"
          :id="item.reactable_id"
          class="mr-5"
        />

        <favorite-button
          :to="item.reactable_type"
          :id="item.reactable_id"
          class="mr-5"
        />

        <bookmark-button
          :to="item.reactable_type"
          :id="item.reactable_id"
        />
      </div>
    </template>
  </b-table>
</template>

<script>
import LikeButton from '@/components/reactions/LikeButton'
import FavoriteButton from '@/components/reactions/FavoriteButton'
import BookmarkButton from '@/components/reactions/BookmarkButton'

export default {
  name: 'ReactionGallery',

  components: {
    LikeButton,
    FavoriteButton,
    BookmarkButton
  },

  data () {
    return {
      fields: [
        {
          key: 'index',
          label: 'No'
        },
        'reactable',
        'actions'
      ],

      reactables: [
        {
          title: 'Number Dashboard',
          link: '/dashboard/1',
          reactable_type: 'App\\Dashboard',
          reactable_id: 1
        },
        {
          title: 'Chart Dashboard',
          link: '/dashboard/2',
          reactable_type: 'App\\Dashboard',
          reactable_id: 2
        },
        {
          title: 'Table Dashboard',
          link: '/dashboard/3',
          reactable_type: 'App\\Dashboard',
          reactable_id: 3
        }
      ]
    }
  }
}
</script>
